



























































































import Vue from "vue";

import moment from "moment";
import store from "@/store";

import { GetTenderSituationResponse } from "@/api/dto/Tender";
import { getTenderSituation } from "@/api/Tender";
import { Pending } from "@/api/dto/DealStatus";
import { getReview, checkTdsNotExecuted } from "@/api/Review";
import { PurchaseType } from "@/api/dto/PurchaseType";

/** data の型定義 */
type Data = {
  /** 取引 ID */
  dealId: string;
  /** 選択した入札 */
  selectedTenderUserId: string;
  /** 入札状況一覧 */
  situationList: GetTenderSituationResponse[];
};

/**
 * 入札一覧画面
 */
export default Vue.extend({
  name: "Tender",
  data(): Data {
    return {
      dealId: "",
      selectedTenderUserId: "",
      situationList: [],
    };
  },
  created() {
    this.load(this.$route.params.dealId);
  },
  async beforeRouteEnter(to, from, next) {
    try {
      // 3Dセキュア認証不正結果チェック
      await checkTdsNotExecuted();
      // レビュー情報取得
      const { purchaseUserId, dealStatus, purchaseType } = await getReview(
        to.params.dealId
      );

      // 以下条件全てに該当する場合は、当画面表示
      //  ・ログインユーザーが依頼作成者本人の場合
      //  ・依頼種別（方法）= 1 (入札)
      //  ・取引ステータス = 2 (受注待ち)
      if (
        purchaseUserId == store.getters.userProfile.userId &&
        dealStatus === Pending &&
        purchaseType === PurchaseType.Tendered
      ) {
        next();
      } else {
        next({ name: "Top" });
      }
    } catch (e) {
      // APIエラー、依頼が存在しない場合
      next({ name: "Top" });
    }
  },
  methods: {
    /** 初期表示 */
    async load(dealId: string) {
      // store にセット
      this.$store.dispatch("initTenderUser");
      this.dealId = dealId;
      try {
        // 入札状況取得
        this.situationList = await getTenderSituation(this.dealId);
      } catch (e) {
        this.$emit(
          "errorToast",
          "入札状況取得ができませんでした。しばらく経ってからやり直してください。"
        );
      }
    },
    /** ラジオボタン change ハンドラ */
    handleChangeRadio(tenderUserId: string, amount: number) {
      // store にセット
      this.$store.dispatch("selectTenderUser", { tenderUserId, amount });
      this.selectedTenderUserId = tenderUserId;
    },
    /** 依頼詳細を表示ボタン click ハンドラ */
    handleClickReviewDetail() {
      this.$router.push({
        name: "Review",
        params: { dealId: this.dealId },
      });
    },
    /** 支払情報の入力へ click ハンドラ */
    handleClickPaymentForm() {
      if (!this.selectedTenderUserId) {
        this.$emit("errorToast", "入札者を選択してください");
        return;
      }
      this.$router.push({
        name: "TenderPayout",
        params: { dealId: this.dealId },
      });
    },
    /** 遷移元に移動 */
    toPreviousPage() {
      this.$router.push({ name: "DealsManagement" });
    },
    /** 日時フォーマット */
    formatDate(date: Date) {
      return moment(date).format("YYYY年MM月DD日 HH:MM");
    },
  },
});
